module.exports = __webpack_public_path__ + "media/images/jbandassociatesph-2135b564798a2cd2cafa930b7d754feb.png";